import * as React from 'react';
import { Card, Breadcrumb, Avatar, Row, Col, Divider, Badge  } from 'antd';
import '../css/Dashboard.scss';
import service from '../service/apolloclient.service';
import { Link } from 'react-router-dom';
import LocalStorage from '../service/localstorage';
import NoActiveOrganization from './NoActiveOrg';
import Auth from './common/auth';
import { Tasks } from './common/auth';
import { STATICKEYS, staticProperties } from './common/staticProperties';
import strings from '../eyeguide-localization/strings.dashboard';
import { VIEWSTATE, ZENDESKTOKENTYPE } from './common/constants';
import Token from './common/token';
import AdminDashboard from './AdminDashboard';

const userIcon = require('../images/illustration-profile.png');
const storage = new LocalStorage();
// const zendeskscriptsrc = 'https://static.zdassets.com/ekr/snippet.js?key=2fec5868-8029-4355-8809-7658333c23ea';

interface IdashboardProps {
    firstname: string;
    isOrgSpecific: boolean;
    orgId: any;
    setSelectedOrg: any;
    location: any;
}

interface IDashboardState {
    totalProfiles: number;
    totalBaselines: number;
    totalTests: number;
    noOfBaseline: number;
    noOfProfiles: number;
    noOfProfilesImpaired: number;
    loading: boolean;
    noActiveOrg: boolean;
    isNoOrg: boolean;
    isOrgSpecific: boolean;
    orgId: any;
    isFocusUser: boolean;
}

export default class Dashboard extends React.Component<IdashboardProps, IDashboardState> {
 
    constructor(props: IdashboardProps) {
        super(props);
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        console.log('dasborad roleid', roleid);
        this.state = {
            totalProfiles: 0,
            totalBaselines: 0,
            totalTests: 0,
            noOfBaseline: 0,
            noOfProfiles: 0,
            noOfProfilesImpaired: 0,
            loading: true,
            noActiveOrg: false,
            isNoOrg: Auth.canPerformTask(roleid, Tasks.isNoOrg) && storage.getSelectedOrg() === '',
            isFocusUser: Auth.canPerformTask(roleid, Tasks.isFocusUser),
            isOrgSpecific: false,
            orgId: ''
        };
    }

    componentDidMount() {
        document.title = 'EyeGuide';
        console.log('dashboard componentDidMount');
        staticProperties.set(STATICKEYS.rerender, true);
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.HOME);

        if (!this.props.isOrgSpecific && !this.state.isFocusUser) {
        let token = this.decodeToken(storage.getToken());
        console.log('decodeToken', token);
        if (token.organizations.length > 0 ) {
        this.getOrgValues();
        } else {
            this.setState({
                loading: false,
                    noActiveOrg: this.state.isFocusUser ? this.state.isNoOrg ? 
                                    false : storage.getSelectedOrg() === '' ? false : true : true
            });
        }
        } else if (this.props.isOrgSpecific) {
            this.getOrgValuesByOrgId(this.props.orgId);
        }
        
        // Disabled zendesk - 11/11/2021 
        // this.addZendeskWebWidget();
    }

    componentWillReceiveProps(nextProps: any) {
        console.log('dashboard componentWillReceiveProps');
        if (this.props.orgId !== nextProps.orgId && nextProps.orgId === undefined) {
            this.setState({
                isNoOrg: true
            });
            return;
        }
        if (this.props.orgId !== nextProps.orgId) {
            staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.HOME);
            this.setState({
                loading: true,
                noActiveOrg: false,
                isNoOrg: false
            });
            if (!nextProps.isOrgSpecific) {
                let token = this.decodeToken(storage.getToken());
                console.log('decodeToken', token);
                if (token.organizations.length > 0 ) {
                    this.getOrgValues();
                } else {
                    this.setState({
                        loading: false,
                        noActiveOrg: this.state.isNoOrg ? false : storage.getSelectedOrg() === '' ? false : true
                    });
                }
            } else {
                console.log('nextProps.orgId', nextProps.orgId);
                this.getOrgValuesByOrgId(nextProps.orgId);
            }
        }
        
        console.log('Dashboard verifyZendeskToken');
        Token.verifyZendeskToken(ZENDESKTOKENTYPE.WIDGET, storage.getZendeskWidgetToken())
        .then((newToken) => {
            if ( newToken !== undefined && newToken !== '' ) {
                console.log('Dashboard zendesk widget token: ', newToken);
                storage.setZendeskWidgetToken(newToken);
            }
        });
    }

    render() {

        let stmt1 = this.state.noOfBaseline + strings.lsBaselineCntTxt;
        let stmt2 = this.state.noOfProfiles + strings.lsProfileTxt;
        let stmt3 = this.state.noOfProfilesImpaired + strings.lsImpairedProfileTxt;
        console.log('isNoOrg', this.state.isNoOrg);
        console.log('noActiveOrg', this.state.noActiveOrg);
        return (
            // <div>Dashbaord</div>

            <div className="Dashboard">
            {
                this.state.isOrgSpecific &&
                <AdminDashboard location={this.props.location} />
            }
            {this.state.isNoOrg ? <AdminDashboard location={this.props.location} />
                : 
                this.state.noActiveOrg ? <NoActiveOrganization />
                :
                <div>
            <Card loading={this.state.loading}>
                <Breadcrumb>
                    <Breadcrumb.Item > <a href="/dashboard"> {strings.lsBreadCrumNavigatorTxt} / </a> </Breadcrumb.Item>
                </Breadcrumb>
                <br/>
                <div>
                    <Row>
                        <Col xs={8} sm={4} md={4} lg={3} xl={2}>
                            <Avatar 
                                src={userIcon}
                                style={{ backgroundColor: '#8B9FB2' }} 
                                icon="Image" 
                                size="large"
                                shape="circle"
                                className="userImage"
                            />
                        </Col>                   
             
                            <Col  xs={10} sm={5} md={6} lg={6} xl={7}>
                            <div>    
                                <Row className="greetings">
                                    {this.getGreetingMsg() + ', ' + this.props.firstname + '.'}
                                </Row>
                                <Row className="overviewMsg">
                                    {strings.lsOverviewTxt}
                                </Row>
                                </div>
                            </Col>                

                        <div>                 
                            <Col  xs={10} sm={15} md={14} lg={15} xl={15}>
                            <div>
                                <Row>
                                    <Col xs={10} sm={1} md={1} lg={8} xl={10}/>
                                    <Col xs={10} sm={7} md={7} lg={5} xl={4}>
                                    <Row className="countLabels">
                                        {strings.lsTotalProfileTxt}
                                    </Row>
                                    <Row className="countValues">
                                        {this.state.totalProfiles.toString()}
                                    </Row>
                                    </Col>
                               
                                    <Col xs={10} sm={2} md={2} lg={1} xl={1}>
                                    <div>
                                    <Divider className="dividerLine" type="vertical"/>
                                    </div>
                                    </Col>

                                    <Col xs={10} sm={7} md={7} lg={5} xl={4}>
                                        <Row className="countLabels">
                                            {strings.lsTotalBaselineTxt}
                                        </Row>
                                        <Row className="countValues">
                                            {this.state.totalBaselines.toString()}
                                        </Row>
                                    </Col>
  
                                    <Col xs={10} sm={2} md={2} lg={1} xl={1}>
                                    <Row>
                                    <div>
                                    <Divider className="dividerLine" type="vertical"/>
                                    </div>
                                    </Row>
                                    </Col>
    
                                    <Col xs={10} sm={5} md={5} lg={4} xl={4}>
                                        <Row className="countLabels">
                                            {strings.lsTotalTestTxt}
                                        </Row>
                                        <Row className="countValues">
                                         {(this.state.totalTests - this.state.totalBaselines).toString()}
                                        </Row>
                                    </Col>
                                </Row>
                                </div>
                            </Col>                
                        </div>
                  </Row>
                </div>
            </Card>

            <Card loading={this.state.loading} className="cardOverviewOwn cardOverview">

                <div className="cardOverViewContent overviewTitile"> Overview </div>
                <Divider />
                <div className="cardOverViewContent">
                <Row>
                    <Col xs={18} sm={12} md={12} lg={8} xl={8}>
                        <Badge className="badgeText" status="processing" text={stmt1}/>
                    </Col>
                    <Col xs={6} sm={12} md={12} lg={16} xl={16}>
                    {/* <span 
                        className="links"
                        onClick={ () => {
                            this.props.viewProfileClicked(Constants.getProfileListTypes().BASELINES_LAST_WEEK); }}
                    >
                        View Profiles
                    </span> */}

                    <Link className="links" to={'/dashboardprofile/baseline/' + this.props.orgId}>
                        {strings.lsViewProfileLinkTxt}
                    </Link>
                                     
                    </Col>
                </Row>

                <div>
                    <Divider/>
                </div>
                <Row>
                    <Col xs={18} sm={12} md={12} lg={8} xl={8}>
                        <Badge className="badgeText" status="processing" text={stmt2}/>
                    </Col>
                    <Col xs={6} sm={12} md={12} lg={16} xl={16}>
                        {/* <span 
                            className="links"
                            onClick={ () => {
                                this.props.viewProfileClicked(Constants.getProfileListTypes().BASELINES_PENDING); }}
                        >
                            View Profiles
                        </span> */}
                    <Link className="links" to={'/dashboardprofile/baselinepending/' + this.props.orgId}>
                        {strings.lsViewProfileLinkTxt}
                    </Link>
                    </Col>
                </Row>

                <div>
                    <Divider />
                </div>
                 <Row>
                    <Col xs={18} sm={12} md={12} lg={8} xl={8}>
                        <Badge className="badgeText" status="processing" text={stmt3}/>
                    </Col>
                    <Col xs={6} sm={12} md={12} lg={16} xl={16}>
                    {/* <span 
                        className="links"
                        onClick={ () => {
                            this.props.viewProfileClicked(Constants.getProfileListTypes().IMPAIRED_PROFILES); }}
                    >
                        View Profiles
                    </span> */}
                    <Link className="links" to={'/dashboardprofile/impaired/' + this.props.orgId} >
                        {strings.lsViewProfileLinkTxt}
                    </Link>
                    </Col>
                </Row>
            </div>
            </Card> 
            {/*<Card loading={this.state.loading}  className="cardOverviewOwn cardOverview iosUpdateContent">
                <div className="cardOverViewContent iosUpdateTitle"> {strings.lsIOSUpdateActionTxt} </div>
                    <Divider />
                    <div className="cardOverViewContent iosUpdateText">
                        <div> {strings.lsIOSUpdateTxt}  </div>
                        <div> {strings.lsIOSUpdateTxt2} </div>
                        <Button className="learnBtn"> {strings.lsLearnMoreTxt} </Button>  
                    </div>                  
                </Card> */}
            </div>}
            
            </div>
            
        );
    }

    /*private addZendeskWebWidget() {

        function loadScript() {
            (window as any).zESettings = {           
                authenticate: { jwt: storage.getZendeskWidgetToken() }            
            };
            const script = document.createElement('script');
            script.src = zendeskscriptsrc;
            script.id = 'ze-snippet';
            script.async = true;
            document.body.appendChild(script);          
            return new Promise(res => script.onload = function() { 
                res();
                console.log('loading script.'); 
            });            
        }
      
        loadScript()
        .then(() => {
            console.log('Script loaded!');
            let token = this.decodeToken(storage.getZendeskWidgetToken());        
            const identifyscript = document.createElement('script');
            let username: string = token !== undefined ? token.name : '';
            let email: string = token !== undefined ? token.email : '';
            identifyscript.text = 'zE(function() {zE.identify({name: ' + '\'' + username + '\'' 
            + ', email: ' + '\'' + email + '\'' + '});});';        
            console.log('identifyscript: ', identifyscript.text); 
            document.body.appendChild(identifyscript);
        });       
    }*/
    /**
     * Gets the greeting message as per current time to display on dashboard
     */
    private getGreetingMsg() {
        let currHours = new Date().getHours();
        if (currHours >= 12 && currHours < 18) { 
            return strings.lsGreetingAftrnTxt; // 'Good Afternoon';
        } else if (currHours >= 18 && currHours <= 23 ) {
            return strings.lsGreetingEveTxt;
        } else {
            return strings.lsGreetingMrngTxt;
        }
    }

    /**
     * Gets all counter values from server to display on dashboard
     */
    private async getOrgValues() {
        let ser = new service();
        console.log('getOrgValues');
        let value: any = await ser.getOrganizationsWithCounts();
        console.log('getOrgValues', value);
        this.setDashboardcounts(value);

    }

    private setDashboardcounts(values: any) {
        console.log('setDashboardcounts');
        let athletes: number = 0;
        let baselines: number = 0;
        let tests: number = 0;
        let baselinesWeek: number = 0;
        let pendingBaselines: number = 0;
        let impairedProfiles: number = 0;
        values.map( (x: any) => {
            athletes += x.totalAthletes;
            pendingBaselines += x.totalBaselinePending;
            impairedProfiles += x.totalImpairedTests;
            baselines += x.totalBaselines;
            tests   += x.totalTests  ; 
            baselinesWeek += x.totalBaselinesThisWeek;
        }); 
        this.setState({
            totalProfiles: athletes,
            totalBaselines: baselines,
            totalTests: tests,
            noOfBaseline: baselinesWeek,
            noOfProfiles: pendingBaselines,
            noOfProfilesImpaired: impairedProfiles,
            loading: false,
            noActiveOrg: false,
            isNoOrg: false
        });
        console.log('athletes', athletes);
    }

    private async getOrgValuesByOrgId(orgId: any) {
        console.log('componentWillReceiveProps');
        let ser = new service();
        let resp = await ser.getDashboardCounts(orgId);
        console.log('response of dashboard counts', resp);
        this.setDashboardcounts(resp);
        this.props.setSelectedOrg(resp);
    }

    private decodeToken(token: any) {
        if (token !== undefined) {
          let base64Url = token.split('.')[1];   
          let base64 = base64Url.replace('-', '+').replace('_', '/');
          return JSON.parse(window.atob(base64));
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/Dashboard.tsx